// extracted by mini-css-extract-plugin
module.exports = {"container":"Events_container__2ss6o"};